import React from 'react';

/**
 * 必須アイコン
 *
 * @param {boolean} { isShow = true } 表示するかどうか(デフォルトは表示)
 * @returns
 */
const CcusRequireIcon = ({ isShow = true }) => {
  return isShow && <span className='CcusRequiredIcon'>CCUS必須</span>;
};

export default CcusRequireIcon;



// WEBPACK FOOTER //
// ./src/components/CcusRequireIcon.jsx